import { make } from 'vuex-pathify'
import dottie from 'dottie'
import { api } from '@/api'

const state = {
  account: {}
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state),

  created(state, { account }) {
    state.account = account
  },

  creationFailed() {},

  read(state, { account }) {
    state.account = account
  },

  readFailed(state) {
    state.account = {}
  },

  updated(state, { account }) {
    state.account = account
  },

  updateFailed() {},

  deleted(state) {
    state.account = {}
  },

  deleteFailed() {},

  reseted(state) {
    state.account = {}
  }
}

const actions = {
  async reset({ commit }) {
    commit('reseted')
  },

  async create({ commit }, data) {
    try {
      const response = await api.put('/accounts', state.account)
      const account = dottie.get(response, 'data.account', null)
      commit('created', { account })
    } catch (e) {
      commit('creationFailed')
    }
  },

  async read({ state, commit }, id) {
    try {
      const response = await api.get(`/accounts/${id}`)
      const account = dottie.get(response, 'data.account', null)
      commit('read', { account })
    } catch (e) {
      commit('readFailed')
    }
  },

  async update({ state, commit }) {
    try {
      const response = await api.put(
        `/accounts/${state.account._id}`,
        state.account
      )
      const account = dottie.get(response, 'data.account', null)
      commit('updated', { account })
    } catch (e) {
      commit('updateFailed')
    }
  },

  async delete({ state, commit }) {
    try {
      const response = await api.delete(`/accounts/${state.account._id}`)
      if (response.status === 200) commit('deleted')
    } catch (e) {
      commit('deleteFailed')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
